import React from 'react'
import styles from "../components/laymanComp_css/LaymanPage37.module.css"
import { Link } from '@mui/material'

export default function LaymanPage37() {
  return (
    <>
      <div className={styles.layman_block_2}>
          <div className={styles.block1_main_wrpr}>
            <div className={styles.block1_main_bg}>
            <div className={styles.common_width_1}>
              <div className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}>
                <div className={styles.column}>
                  <div className={`${styles.col12} ${styles.bgifive}`}>
                    <h1>ARCHETYPE OF SAGITTARIUS</h1>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.common_width}>
              <div className={styles.layman_sagittarius_block_main}>
                <div className={`${styles.sagittarius_block1_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}>
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img
                      className={styles.sagittarius_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_sagittarius/sagittarius_block1_img.webp"
                    /> */}

                    <img
                      className={styles.archetype_img1}
                      src={`${process.env.cloud_url}Layman-Symbolism/layman_page_sagittarius/sagittarius_block1_img.webp`}
                    />
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>

                      <div className={styles.yellow_box_heading}>
                        <h1>The Cosmic Alchemy of Sagittarius: A Journey through Divine Infinite Being and Archetypal Astrology</h1>
                      </div>

                      <p>In the realm of <Link href="https://www.divineinfinitebeing.com">Divine Infinite Being</Link> and Archetypal Astrology, Sagittarius stands as a powerful cosmic archetype, a mutable fire influence that has woven its brilliance into the very fabric of human creativity and artistry. This celestial archer, drawing back its bow, sends forth arrows of inspiration that have left an indelible mark on history, particularly during the Renaissance.</p>

                      <div className={styles.yellow_box_heading}>
                        <h1>The Renaissance Explosion: A Symphony of Sagittarian Artistry</h1>
                      </div>

                      <p>The Renaissance, a period of profound cultural and artistic rebirth, was a manifestation of the Sagittarian archetype. This era witnessed an explosion of art, music, and theater, reminiscent of the cosmic arrows shot forth by the celestial archer. The works of visionaries like Leonardo da Vinci and the invention of the Tarot are testaments to the Sagittarian influence that permeated this transformative age.</p>

                      <p>The mutable fire of Sagittarius illuminated the world with the graces of creativity, much like the dance of Tai Chi, a flow that echoes the essence of Sagittarian energy. The echoes of Sagittarian melodies lingered in the air as artists painted, musicians composed, and the stage came alive with the spirit of exploration and expression.</p>
                    </div>
                  </div>
                </div>

                <div className={`${styles.sagittarius_block2_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}>
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_sagittarius/sagittarius_block2_img.webp" /> */}

                    <img
                      className={styles.archetype_img1}
                      src={`${process.env.cloud_url}Layman-Symbolism/layman_page_sagittarius/sagittarius_block2_img.webp`}
                    />
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>

                      <div className={styles.yellow_box_heading}>
                        <h1>The Alchemical Dance: Sagittarius and the Art of Transformation</h1>
                      </div>

                      <p>The Alchemist archetype finds a unique kinship with Sagittarius, engaging in a cosmic dance of synthesis and transmutation. In the alchemical process, akin to the archer's aim, the alchemist strives to distill the lead of existence into the gold of inner creativity. The bow is drawn, and the arrow is released, seeking the elusive secret ingredient that transforms not just base metals but the alchemist themselves.</p>

                      <p>The Thoth Arcana <span><i>"Art"</i></span> and Temperance in other decks depict the androgynous alchemist, navigating the alchemical dance. This final ingredient, the Azoth, the inner light, becomes the catalyst for transfiguration – an alchemical journey from the innermost depths to the outer realms of creativity.</p>

                      <div className={styles.yellow_box_heading}>
                        <h1>Engaging Sagittarian Alchemy: Distilling the Essence of Creativity</h1>
                      </div>

                      <p>To work under the influence of Sagittarius is to embark on a personal alchemical journey, distilling the highest expressions of the heart and tempering methods towards the rewards of the talented artist. The arrow of time, shot from the bow of the celestial archer, becomes a reflection of our evolution from ancestral past to immediate future.</p>

                      <p>In the alchemist's laboratory of life, Sagittarian energy encourages us to synthesize our experiences, distill our passions, and transmute our inner light into outer creativity. It beckons us to engage willingly in the cosmic alchemy of personal transformation, where the reward is not only the gold of artistic achievement but the profound metamorphosis of the artist themselves.</p>

                      <p>As we draw inspiration from the celestial archer, we step into the dance of Sagittarian alchemy, where the arrows of creativity pierce the fabric of existence, leaving behind a tapestry woven with the brilliance of mutable fire. In this dance, we find the essence of Sagittarius – a cosmic force that propels us towards the limitless horizons of our creative potential.</p>
                    </div>
                  </div>
                </div>

                <div className={`${styles.sagittarius_block3_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}>
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img
                      className={styles.sagittarius_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_sagittarius/sagittarius_block3_img.webp"
                    /> */}

                    <img
                      className={styles.archetype_img1}
                      src={`${process.env.cloud_url}Layman-Symbolism/layman_page_sagittarius/sagittarius_block3_img.webp`}
                    />
                  </div>

                  <div className={`${styles.layman_txt_box_wrpr} ${styles.bullet_cont}`}>
                    <div className={styles.layman_txt_box_innr}>

                    <div className={styles.yellow_box_heading}>
                      <h1>Engaging Sagittarian Alchemy: Distilling the Essence of Creativity</h1>
                    </div>

                    <h4>Mutable Fire Influence:</h4>

                    <p>Sagittarius embodies the qualities of a Mutable Fire Influence, signifying adaptability and dynamic energy.</p>

                    <h4>Radiant Cosmic Archetype:</h4>

                    <p>As a Cosmic Archetype, Sagittarius radiates transformative and creative energies, inspiring exploration and growth.</p>

                    <h4>Renaissance Resurgence:</h4>

                    <p>During the Renaissance, Sagittarian influence surged, contributing to a cultural renaissance marked by artistic brilliance and intellectual innovation.</p>

                    <h4>Da Vinci's Artistic Brilliance:</h4>

                    <p>The works of Leonardo Da Vinci, influenced by Sagittarius, showcase a fusion of artistic brilliance, scientific curiosity, and inventive genius.</p>

                    <h4>Harmony in Music and Dance:</h4>

                    <p>Sagittarius influences the world's rhythmic harmony, expressed through music, dance, and the graceful movements of practices like Tai Chi.</p>
                    </div>
                  </div>
                </div>

                <div className={`${styles.sagittarius_block4_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}>
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_sagittarius/sagittarius_block4_img.webp" /> */}

                    <img
                      className={styles.archetype_img1}
                      src={`${process.env.cloud_url}Layman-Symbolism/layman_page_sagittarius/sagittarius_block4_img.webp`}
                    />
                  </div>
                  
                  <div className={`${styles.layman_txt_box_wrpr} ${styles.bullet_cont}`}>
                    <div className={styles.layman_txt_box_innr}>

                    <div className={styles.yellow_box_heading}>
                      <h1>Engaging Sagittarian Alchemy: Distilling the Essence of Creativity</h1>
                    </div>

                    <h4>Symbolic Archer's Bow:</h4>

                    <p>Symbolized by the archer's bow, Sagittarius represents the release of the arrow of time across the vast canvas of history, symbolizing both reflection and anticipation.</p>

                    <h4>Alchemical Synthesis and Transformation:</h4>

                    <p>Sagittarius shares a symbiotic relationship with alchemical processes, influencing the Alchemist's quest for synthesis, transformation, and the release of inner creativity.</p>

                    <h4>Thoth Arcana Art:</h4>

                    <p>In the Thoth Tarot, the Arcana <span><i>"Art"</i></span> illustrates the Alchemist's transformative journey, emphasizing the synthesis of inner light for personal transfiguration.</p>

                    <h4>Androgynous Alchemist in Temperance:</h4>

                    <p>The figure of the Androgynous Alchemist in Temperance cards signifies the balanced integration of opposing forces, a hallmark of Sagittarian influence.</p>

                    <h4>Cosmic Tapestry of Human Experience:</h4>

                    <p>Sagittarius, as a guiding star in the cosmic tapestry, encourages individuals to explore their creative potential and embark on a transformative journey of self-discovery.</p>

                    <p>Incorporating the astrological features of Sagittarius allows individuals to align with the dynamic and creative energies of this Archetype, fostering personal growth, exploration, and the pursuit of artistic expression.</p>
                    </div>
                  </div>
                </div>

                <div className={styles.green_sec_cmn_main_wrp}>
                  
                    <Link href="/rota-the-wheel">
                      <div className={styles.green_sec_cmn_sub_wrp}>
                        <h1>The Astrological Tarot association for Gemini is <br/>The Lovers. See our alchemical ROTA here</h1>
                      </div>
                    </Link>
                  
                </div>
              </div>
            </div>

            {/* <div className={styles.demo_image}>
              <div className={styles.block1_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_sagittarius/layman_page37_block1_demo_img.webp'></img>
              </div>

              <div className={styles.block2_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_sagittarius/layman_page37_block2_demo_img.webp'></img>
              </div>

              <div className={styles.block3_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_sagittarius/layman_page37_block3_demo_img.webp'></img>
              </div>

              <div className={styles.block4_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_sagittarius/layman_page37_block4_demo_img.webp'></img>
              </div>

              <div className={styles.block5_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_sagittarius/layman_page37_block5_demo_img.webp'></img>
                <Link className={styles.blank_link} href="/rota-the-wheel"></Link>
              </div>
            </div> */}
            </div>
          </div>
        </div>
    </>
  )
}